const STORAGE_KEY = 'navPanelOpen';
const DEFAULT_VALUE = window.innerWidth >= 640;
export function isNavPanelOpen(context) {
    const storage = context.getMethodsOf('storage');
    const open = storage.getItem(STORAGE_KEY);
    return typeof open === 'boolean' ? open : DEFAULT_VALUE;
}
export function openNavPanel(context, open) {
    const storage = context.getMethodsOf('storage');
    storage.setItem(STORAGE_KEY, open);
}
